var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group" }, [
    _c("label", {
      attrs: { for: _vm.name },
      domProps: { innerHTML: _vm._s(_vm.label) }
    }),
    _vm._v(" "),
    _c("input", {
      ref: "timepicker",
      staticClass: "form-control",
      class: { "is-invalid": _vm.error !== "" },
      attrs: {
        type: "text",
        name: _vm.name,
        id: _vm.name,
        placeholder: _vm.placeholder,
        min: _vm.min
      },
      domProps: { value: _vm.value },
      on: {
        input: function($event) {
          return _vm.updateValue($event.target.value)
        }
      }
    }),
    _vm._v(" "),
    _vm.error !== ""
      ? _c("div", {
          staticClass: "invalid-feedback",
          domProps: { innerHTML: _vm._s(_vm.error) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/fields/TimeField.vue?vue&type=template&id=169ef96a&
// module id = 420
// module chunks = 0